/**
 * Protected Route Component
 * Redirects to login if not authenticated, preserving the intended destination
 * so the user is sent back there after a successful login.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    const destination = `${location.pathname}${location.search || ''}${location.hash || ''}`;
    try {
      localStorage.setItem('wikigame:redirect-after-login', destination);
    } catch (e) {
      console.error('Failed to save redirect destination:', e);
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
